(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    // Store initialized containers to avoid re-initializing
  const initializedContainers = new WeakSet();
  
  // Function to initialize tabs for a container
  function initializeTabs(tabsContainer) {
    // Skip if already initialized and content hasn't changed
    if (initializedContainers.has(tabsContainer)) {
      return;
    }
    
    const navigation = tabsContainer.querySelector('.product-tabs__navigation');
    const panels = tabsContainer.querySelectorAll('.product-tabs__panel');
    
    // Clear existing navigation buttons
    navigation.innerHTML = '';
    
    // Filter panels to only include those with content
    const panelsWithContent = Array.from(panels).filter(panel => {
      const contentElement = panel.querySelector('.product-tabs__panel-content');
      if (!contentElement) return false;
      
      // Check if content element has meaningful text content
      const textContent = contentElement.textContent.trim();
      const hasVisibleElements = contentElement.querySelector('p, h1, h2, h3, h4, h5, h6, ul, ol, img, video, iframe, div');
      
      return textContent.length > 0 && hasVisibleElements;
    });
    
    // If no panels have content, hide the entire tabs container
    if (panelsWithContent.length === 0) {
      tabsContainer.style.display = 'none';
      initializedContainers.add(tabsContainer);
      return;
    }
    
    // Show the tabs container
    tabsContainer.style.display = '';
    
    // Reset all panels to default state
    panels.forEach(panel => {
      panel.classList.remove('product-tabs__panel--active');
      panel.style.display = '';
    });
    
    // Hide panels without content
    panels.forEach(panel => {
      if (!panelsWithContent.includes(panel)) {
        panel.style.display = 'none';
      }
    });
    
    // Build navigation from panels with content
    panelsWithContent.forEach((panel, index) => {
      const title = panel.dataset.tabTitle || `Tab ${index + 1}`;
      const isFirst = index === 0;
      
      const button = document.createElement('button');
      button.className = `product-tabs__tab${isFirst ? ' product-tabs__tab--active' : ''}`;
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-selected', isFirst.toString());
      button.setAttribute('aria-controls', `tab-content-${index}`);
      button.setAttribute('id', `tab-${index}`);
      button.dataset.tabIndex = index;
      button.textContent = title;
      
      // Set panel attributes to match
      panel.setAttribute('aria-labelledby', `tab-${index}`);
      panel.setAttribute('id', `tab-content-${index}`);
      
      navigation.appendChild(button);
    });
    
    const tabs = navigation.querySelectorAll('.product-tabs__tab');
    
    function switchTab(activeIndex) {
      tabs.forEach((tab, index) => {
        const isActive = index === activeIndex;
        tab.classList.toggle('product-tabs__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive.toString());
      });
      
      panelsWithContent.forEach((panel, index) => {
        const isActive = index === activeIndex;
        panel.classList.toggle('product-tabs__panel--active', isActive);
        if (isActive) {
          panel.style.display = 'block';
        } else {
          panel.style.display = 'none';
        }
      });
    }
    
    // Use event delegation for better performance
    navigation.addEventListener('click', (event) => {
      const tab = event.target.closest('.product-tabs__tab');
      if (tab) {
        const index = parseInt(tab.dataset.tabIndex);
        switchTab(index);
      }
    });
    
    if (panelsWithContent.length > 0) {
      switchTab(0);
    }
    
    // Mark as initialized
    initializedContainers.add(tabsContainer);
  }

  // Debounced function to reinitialize tabs
  let reinitTimeout;
  function debouncedReinit() {
    clearTimeout(reinitTimeout);
    reinitTimeout = setTimeout(() => {
      document.querySelectorAll('.product-tabs').forEach(container => {
        // Clear initialization flag to force re-init
        initializedContainers.delete(container);
        initializeTabs(container);
      });
    }, 100);
  }

  // Initialize tabs on DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-tabs').forEach(initializeTabs);
  });

  // Reinitialize tabs when theme customizer updates content
  document.addEventListener('shopify:section:load', (event) => {
    const tabsContainer = event.target.querySelector('.product-tabs');
    if (tabsContainer) {
      // Clear initialization flag for this specific container
      initializedContainers.delete(tabsContainer);
      initializeTabs(tabsContainer);
    }
  });

  // Listen for content changes in existing tabs containers only
  document.addEventListener('shopify:section:reorder', debouncedReinit);
  document.addEventListener('shopify:block:select', debouncedReinit);
  document.addEventListener('shopify:block:deselect', debouncedReinit);

  // Only use heavy MutationObserver in design mode
  function isInDesignMode() {
    return document.body.classList.contains('shopify-theme-inspector') || 
           window.Shopify?.designMode || 
           document.querySelector('[data-shopify-editor-toolbar]') ||
           window.location.search.includes('preview_theme_id');
  }

  // Lightweight fallback for design mode with MutationObserver
  if (window.MutationObserver && isInDesignMode()) {
    const observer = new MutationObserver((mutations) => {
      let shouldReinit = false;
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Check if the added node is a product-tabs container
              if (node.classList && node.classList.contains('product-tabs')) {
                shouldReinit = true;
              }
              // Check if the added node contains product-tabs containers
              const tabsContainers = node.querySelectorAll && node.querySelectorAll('.product-tabs');
              if (tabsContainers && tabsContainers.length > 0) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      
      if (shouldReinit) {
        debouncedReinit();
      }
    });

    // Start observing when DOM is ready
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
